import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import { MobilePushListPage } from './list';

export const MobilePushModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setPageTitle([
        { title: 'Messaging', path: '/messaging/sms' },
        { title: 'Mobile Push', path: '.' }
      ])
    );
  }, []);

  return (
    <>
      <Routes>
        <Route path="/*" element={<MobilePushListPage />} />
      </Routes>
    </>
  );
};
